import { Notifications } from "@/features/account/notifications";

export const Route = createFileRoute({
  component: Notifications,
});
